// extracted by mini-css-extract-plugin
export default {"container":"MyPropertiesPage_container__sU4Zd","heading":"MyPropertiesPage_heading__tiJDB"};